import { customInstance } from "@/lib/api/client";
import { bulkMatchNames } from "@/lib/api/generated";
import type { BulkMatchRequestField } from "@/lib/api/model";
import type { CsvResolver, ResolvedItem } from "@/stores/csv-import-store";

export function createNameMatchResolver(
  field: BulkMatchRequestField,
): CsvResolver {
  return async (values: string[]): Promise<ResolvedItem[]> => {
    const resp = await bulkMatchNames({ names: values, field });

    return resp.results.map((r) => ({
      inputValue: r.input_name,
      matched: r.matched ?? false,
      name: r.name ?? undefined,
      domain: r.domain ?? undefined,
    }));
  };
}

interface LinkedinResolveResult {
  input_url: string;
  normalized_url?: string | null;
  matched: boolean;
  candidate_id?: string | null;
  full_name?: string | null;
}

interface LinkedinResolveResponse {
  results: LinkedinResolveResult[];
  matched_count: number;
  unmatched_count: number;
}

/** No Orval-generated function exists for this endpoint yet. */
export function createLinkedinUrlResolver(): CsvResolver {
  return async (values: string[]): Promise<ResolvedItem[]> => {
    const resp = await customInstance<LinkedinResolveResponse>(
      "/api/exclusions/people/resolve-linkedin-urls",
      {
        method: "POST",
        body: JSON.stringify({ linkedin_urls: values }),
      },
    );

    return resp.results.map((r) => ({
      inputValue: r.input_url,
      matched: r.matched,
      name: r.full_name ?? r.input_url,
      candidateId: r.candidate_id ?? undefined,
    }));
  };
}
